
<div
  class="show cmp-dev-theme-switcher full-width text-center q-pa-sm"
>
  <div class="content">
    Theme: &nbsp;
    <button class="theme-button q-ma-xs" @click="switchTheme(Theme.CARY)">
      CARY
    </button>
    <button class="theme-button q-ma-xs" @click="switchTheme(Theme.LOOPIA)">
      LOOPIA
    </button>
    <button class="theme-button q-ma-xs" @click="switchTheme(Theme.ACTIVE_24)">
      ACTIVE24
    </button>
    <button class="theme-button q-ma-xs" @click="switchTheme(Theme.ADMIN)">
      ADMIN
    </button>
  </div>
</div>
